import { get } from "lodash";

import { AppEnvironmentConfig } from "./AppConfigs";
import { initAfterConfigLoad } from "../utils";

/* Config from config.json - START */

let configs = {
  REACT_APP_PROVIDER_FINDER_BASE_URL: "",
  REACT_APP_GOOGLE_API_MAP_KEY: "",
};

let baseUrl = configs.REACT_APP_PROVIDER_FINDER_BASE_URL;
let mapKey = configs.REACT_APP_GOOGLE_API_MAP_KEY;

function updateConfigs(data) {
  configs = data;
  baseUrl = data.REACT_APP_PROVIDER_FINDER_BASE_URL;
  mapKey = data.REACT_APP_GOOGLE_API_MAP_KEY;
  initAfterConfigLoad();
}

/* Config from config.json - END */

/* App level config constants - START */

//Check if running as localhost
export const IS_LOCALHOST =
  get(process.env, "NODE_ENV", "") === AppEnvironmentConfig.DEV;

//Applied endpoint for localhost -> can be changed via CLI e.g. set REACT_APP_ENDPOINT_ENV=SB
export const REACT_APP_ENDPOINT_ENV = get(
  process.env,
  "REACT_APP_ENDPOINT_ENV",
  ""
);

/* App level config constants - END */
export {
  updateConfigs,
  configs,
  baseUrl,
  mapKey,
};
